export default __webpack_public_path__ + "static/media/image6.163f8b36.jpg";